import {
  //Button,
  Card,
  CardContent,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TextField,
  Typography
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Search } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.jsx";
import EnhancedTableHead from "components/EnhancedTableHead/EnhancedTableHead.jsx";
import React from "react";

const CMHContainer = props => {
  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: "auto" }}>
        <Card>
          <CardContent>
            <div>
              {props.assistantActive ? (
                <Typography variant="headline" className="centerCell">
                  {props.brokerName}
                  's Client Messages
                </Typography>
              ) : (
                <Typography variant="headline" className="centerCell">
                  Client Messages
                </Typography>
              )}

              <div
                style={{
                  borderBottom: "1px solid #cccccc69",
                  margin: "5px auto",
                  width: "25%",
                  marginBottom: "20px"
                }}
              />
            </div>

            <Paper style={{ overflowX: "auto" }}>
              <Grid container>
                <Grid
                  item
                  xs={10}
                  sm={10}
                  md={10}
                  style={{
                    margin: "0 auto",
                    display: "flex",
                    marginTop: "20px"
                  }}
                >
                  <TextField
                    id="input-with-icon-textfield"
                    fullWidth
                    style={{ marginBottom: "30px" }}
                    placeholder="Client or Date Created(DD/MM/YYYY)"
                    value={props.searchTerm}
                    onChange={props.handleSearch}
                    label="Search"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      )
                    }}
                  />
                  {/* <Button>Search</Button> */}
                </Grid>
              </Grid>
              <Table>
                <EnhancedTableHead
                  order={props.order}
                  orderBy={props.orderBy}
                  onRequestSort={(event, property) =>
                    props.handleRequestSort(event, property)
                  }
                  rowCount={props.items ? props.items.length : 0}
                  columnData={props.columnData}
                />
                <TableBody>{props.tableBody}</TableBody>
              </Table>
            </Paper>
          </CardContent>
        </Card>
      </GridItem>
    </Grid>
  );
};

export default CMHContainer;



// WEBPACK FOOTER //
// ./src/views/Messaging/containers/CMHContainer.jsx